import React, { useState, useEffect } from "react";
import Spinner from "../../reusables/spinner";
import { motion } from "framer-motion";
import {
  animationValues,
  transitionValues,
} from "../../../utils/pageTransitions";
import Dropdown from "../../reusables/dropdown";
import InputField from "../../reusables/input";
import { connect } from "react-redux";
import DeleteModal from "../../modals/deleteModal";
import EditSupplierModal from "../../modals/editSupplierModal";
import UnSuspendModal from "../../modals/unSuspendModal";
import {
  fetch_approved_suppliers,
  search_approved_suppliers,
  unsuspend_user,
} from "../../../redux/actions/adminActions";
import "../../../styles/admin.css";
import SuspendModal from "../../modals/suspendModal";
import { periods, user_status } from "../../../utils/options";
import Pagination from "../../reusables/pagination";

function AllSuppliers({
  next,
  approvedSuppliers,
  getApprovedSuppliers,
  accessToken,
  searchApprovedSuppliers,
}) {
  let filters = ["business_name", "phone_number", "email_address"];
  const [loading, setLoading] = useState(true);
  let token = accessToken;

  useEffect(() => {
    setLoading(true);
    getApprovedSuppliers({ token, success });
  }, [getApprovedSuppliers, accessToken]);

  const success = () => {
    setLoading(false);
  };

  const [suppliers, setSuppliers] = useState(approvedSuppliers);

  const [filter, setFilter] = useState(filters[0]);

  const [hasFilter, setFiltered] = useState(false);

  const [optionsActive, setOptions] = useState(null);

  const [edit, setEdit] = useState({ modal: false, user: null });

  const [suspendUser, setSuspend] = useState({ modal: false, users: [] });

  const [suggestions, setSuggest] = useState([]);

  const [UnSuspendUser, setUnsuspend] = useState({ modal: false, users: [] });

  const [deleteUser, setDelete] = useState({ modal: false, users: [] });

  const [selectedSuppliers, setSelected] = useState([]);
  const [params, setParams] = useState({});
  // let params = {};

  const handleOptions = (id) => {
    if (optionsActive === null) {
      setOptions(id);
    } else {
      setOptions(null);
    }
  };

  const [selectedTime, setTime] = useState("All dates");
  const handleSelectTime = (Item) => {
    setTime(Item);
    let filter = Item;
    let param = { ...params, ...{ filter: Item } };
    setParams(param);
  };

  useEffect(() => {
    getApprovedSuppliers({ token, success, params });
  }, [params]);

  const [selectedStatus, setStatus] = useState("Status");

  const handleFilter = (status) => {
    setStatus(status);
    setLoading(true);
    let param = { ...params, ...{ status: status } };
    setParams(param);
  };

  const [search, setSearch] = useState("");

  const searchHandler = (e) => {
    e.preventDefault();
    setLoading(true);
    searchApprovedSuppliers(accessToken, filter, search, success);
  };

  const handleSelect = (e) => {
    let updatedList = [...selectedSuppliers];
    if (e.target.checked) {
      updatedList = [...selectedSuppliers, Number(e.target.value)];
    } else {
      updatedList.splice(selectedSuppliers.indexOf(e.target.value), 1);
    }
    setSelected(updatedList);
  };

  const handleSuspend = (status, id) => {
    if (status === "active") {
      setSuspend({
        ...suspendUser,
        modal: true,
        users: [...suspendUser.users, id],
      });
    } else {
      setUnsuspend({
        ...UnSuspendUser,
        modal: true,
        users: [...suspendUser.users, id],
      });
    }
  };

  const handleSuggestions = (e) => {
    let results = [];

    setSuggest(results);
    setSearch(e.target.value.toLowerCase());

    approvedSuppliers.data.map((item) => {
      switch (filter) {
        case "business_name":
          let business_matches = item?.business_name?.match(
            e.target.value.toLowerCase()
          );
          if (business_matches && results.length < 3) {
            results.push(business_matches?.input);
          }
          break;

        case "phone_number":
          let phone_matches = item?.phone_number?.match(
            e.target.value.toLowerCase()
          );
          if (phone_matches && results.length < 3) {
            results.push(phone_matches?.input);
          }
          break;

        case "email_address":
          let email_matches = item?.email_address?.match(
            e.target.value.toLowerCase()
          );
          if (email_matches && results.length < 3) {
            results.push(email_matches?.input);
          }
          break;

        default:
          break;
      }
    });
  };

  const resetSearch = () => {
    setSearch("");
    setLoading(true);
    getApprovedSuppliers({ token, success });
  };

  const onPageChange = (page) => {
    setLoading(true);
    params = { ...params, ...{ page: page } };
    getApprovedSuppliers({ token, success, params });
  };

  return (
    <motion.div
      initial="out"
      animate="in"
      exit="out"
      variants={animationValues}
      transition={transitionValues}
    >
      <div className="pt-3">
        <div className="spaceBetween mobileBlock">
          <div className="searchHolder isRelative ">
            <div className="alignOnly">
              <Dropdown value={filter} className="mx-1">
                {filters.map((item) => (
                  <div
                    className="isClickable hoverGreen"
                    onClick={() => setFilter(item)}
                  >
                    <p className="sectionText px-3 py-2 mb-0">{item}</p>
                  </div>
                ))}
              </Dropdown>
              <InputField
                inputClass="mx-1"
                iconClick={searchHandler}
                value={search}
                onChange={handleSuggestions}
                placeholder={`Search by ${filter}`}
                icon
                iconClass="ri-search-line"
              />

              {search !== "" && (
                <span
                  className="isRed sectionText--small mx-2 isClickable"
                  onClick={resetSearch}
                >
                  Clear Filter
                </span>
              )}
            </div>

            {suggestions?.length > 0 && (
              <div className="suggestions_holder isRelative">
                <div className="suggestions">
                  {suggestions?.map((item) => (
                    <div
                      className="isClickable hoverGreen"
                      onClick={() => {
                        setSearch(item);
                        setSuggest([]);
                      }}
                    >
                      <p className="sectionText px-3 py-2 mb-0">{item}</p>
                    </div>
                  ))}
                </div>
              </div>
            )}
          </div>

          <div className="alignOnly pt-2">
            <button
              className={`btn__filled ${
                !selectedSuppliers.length > 0 && "btn__disabled"
              } hasRadius mx-1`}
              disabled={!selectedSuppliers.length > 0}
              onClick={() => {
                setSuspend({ modal: true, users: selectedSuppliers });
              }}
            >
              Suspend
            </button>

            <button
              className={`btn__red ${
                !selectedSuppliers.length > 0 && "btn__disabled"
              } hasRadius mx-1`}
              disabled={!selectedSuppliers.length > 0}
              onClick={() => {
                setDelete({
                  modal: true,
                  users: [...deleteUser.users, ...selectedSuppliers],
                });
              }}
            >
              Delete
            </button>

            <Dropdown value={selectedTime} className="mx-1">
              {periods?.map((item) => (
                <div
                  className="isClickable hoverGreen"
                  onClick={() => handleSelectTime(item)}
                >
                  <p className="sectionText px-3 py-2 mb-0">{item}</p>
                </div>
              ))}
            </Dropdown>

            <Dropdown value={selectedStatus} className="mx-1">
              {/* <div
                className="isClickable hoverGreen"
                onClick={() => {
                  setStatus("All");
                  setFiltered(false);
                }}
              >
                <p className="sectionText px-3 py-2 mb-0">All</p>
              </div> */}

              {user_status?.map((status) => (
                <div
                  className="isClickable hoverGreen"
                  onClick={() => handleFilter(status)}
                >
                  <p className="sectionText px-3 py-2 mb-0">{status}</p>
                </div>
              ))}
            </Dropdown>
          </div>
        </div>

        <div className="fullHeight py-5 scrollable--mobile">
          {hasFilter ? (
            suppliers?.data.length > 0 ? (
              <table className="table table__custom">
                <thead className="sectionText--small textIsGray table__head pb-2">
                  <tr className="">
                    <th className="">Business Name</th>
                    <th className="vAlign">Manager’s Name</th>
                    <th className="vAlign">Mobile</th>
                    <th className="vAlign">Email</th>
                    <th className="vAlign">Address</th>
                    <th className="vAlign">Date</th>
                    <th className="vAlign">Status</th>
                    <th className="vAlign">Action</th>
                  </tr>
                </thead>
                <tbody>
                  {suppliers?.data.map((item, index) => (
                    <tr className="hasRadius" key={index}>
                      <td className="alignOnly">
                        <input
                          type="checkbox"
                          className="isClickable"
                          value={item.id}
                          onChange={handleSelect}
                          id=""
                        />

                        <div className="mx-1 alignOnly">
                          <div className="supplier__image mx-2">
                            <img
                              src={item?.photograph}
                              className="w-100"
                              alt=""
                            />
                          </div>

                          <p className="mb-0 textIsBold sectionText">
                            {item?.business_name}
                          </p>
                        </div>
                      </td>

                      <td className="pt-4 vAlign">
                        <p className="mb-0  sectionText">
                          {item?.manager_name}
                        </p>
                      </td>

                      <td className="pt-4 vAlign">
                        <p className="mb-0  sectionText">
                          {item?.phone_number}
                        </p>
                      </td>

                      <td className="vAlign pt-4">
                        <p className="mb-0 sectionText">
                          {item?.email_address}
                        </p>
                      </td>

                      <td className="vAlign pt-4 address">
                        <p className="mb-0 sectionText">
                          {item?.business_address}
                        </p>
                      </td>

                      <td className="vAlign pt-4">
                        <p className="mb-0  sectionText">{item?.date}</p>
                      </td>

                      <td className="center pt-3">
                        <div
                          className={`tag ${
                            item?.status === "active" ? "done" : "pending"
                          }`}
                        >
                          {item?.status}
                        </div>
                      </td>

                      <td className="vAlign pt-4">
                        <i
                          class="ri-more-line isClickable"
                          onClick={() => handleOptions(item?.id)}
                        ></i>

                        {optionsActive === item?.id && (
                          <div className="options">
                            <div className="caret"></div>
                            <div className="p-2 textIsBold lAlign sectionText--small">
                              <div
                                className="hasBorder--bottom py-2"
                                onClick={() =>
                                  setEdit({
                                    ...edit,
                                    modal: true,
                                    user: item,
                                  })
                                }
                              >
                                Edit
                              </div>
                              <div
                                className="hasBorder--bottom py-2"
                                onClick={() =>
                                  next(item.id, item?.manager_name)
                                }
                              >
                                Transactions
                              </div>
                              <div
                                className="hasBorder--bottom py-2"
                                onClick={() =>
                                  handleSuspend(item.status, item.id)
                                }
                              >
                                {item?.status === "active"
                                  ? "Suspend"
                                  : "Unsuspend"}
                              </div>
                              <div
                                className="isRed py-2"
                                onClick={() =>
                                  setDelete({
                                    ...deleteUser,
                                    modal: true,
                                    users: [...deleteUser.users, item.id],
                                  })
                                }
                              >
                                Delete
                              </div>
                            </div>
                          </div>
                        )}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            ) : (
              <div className="w-100 sectionHeight--mid vAlign pt-4">
                <h2 className="sectionHead--small textIsBold textIsGreen">
                  No supplier found
                </h2>
              </div>
            )
          ) : !loading ? (
            approvedSuppliers?.data?.length > 0 ? (
              <table className="table table__custom">
                <thead className="sectionText--small textIsGray table__head pb-2">
                  <tr className="">
                    <th className="">Business Name</th>
                    <th className="vAlign">Manager’s Name</th>
                    <th className="vAlign">Mobile</th>
                    <th className="vAlign">Email</th>
                    <th className="vAlign">Address</th>
                    <th className="vAlign">Date</th>
                    <th className="vAlign">Status</th>
                    <th className="vAlign">Action</th>
                  </tr>
                </thead>
                <tbody>
                  {approvedSuppliers?.data?.map((item) => (
                    <tr className="hasRadius">
                      <td className="alignOnly">
                        <input
                          type="checkbox"
                          className="isClickable"
                          name=""
                          value={item.id}
                          id=""
                          onChange={handleSelect}
                        />

                        <div className="mx-1 alignOnly">
                          <div className="supplier__image mx-2">
                            <img
                              src={item?.photograph}
                              className="w-100"
                              alt=""
                            />
                          </div>

                          <p className="mb-0 textIsBold sectionText">
                            {item?.business_name}
                          </p>
                        </div>
                      </td>

                      <td className="pt-4 vAlign">
                        <p className="mb-0  sectionText">
                          {item?.manager_name}
                        </p>
                      </td>

                      <td className="pt-4 vAlign">
                        <p className="mb-0  sectionText">
                          {item?.phone_number}
                        </p>
                      </td>

                      <td className="vAlign pt-4">
                        <p className="mb-0 sectionText">
                          {item?.email_address}
                        </p>
                      </td>

                      <td className="vAlign pt-4 address">
                        <p className="mb-0 sectionText">
                          {item?.business_address}
                        </p>
                      </td>

                      <td className="vAlign pt-4">
                        <p className="mb-0  sectionText">{item?.date}</p>
                      </td>

                      <td className="center pt-3">
                        <div
                          className={`tag ${
                            item?.status === "active" ? "done" : "pending"
                          }`}
                        >
                          {item?.status}
                        </div>
                      </td>

                      <td className="vAlign pt-4">
                        <i
                          class="ri-more-line isClickable"
                          onClick={() => handleOptions(item?.id)}
                        ></i>

                        {optionsActive === item?.id && (
                          <div className="options">
                            <div className="caret"></div>
                            <div className="p-2 textIsBold lAlign sectionText--small">
                              <div
                                className="hasBorder--bottom pb-2"
                                onClick={() =>
                                  setEdit({
                                    ...edit,
                                    modal: true,
                                    user: item,
                                  })
                                }
                              >
                                Edit
                              </div>
                              <div
                                className="hasBorder--bottom pt-2 pb-2"
                                onClick={() =>
                                  next(item.id, item?.manager_name)
                                }
                              >
                                Transactions
                              </div>
                              <div
                                className="hasBorder--bottom py-2"
                                onClick={() =>
                                  handleSuspend(item.status, item.id)
                                }
                              >
                                {item?.status === "active"
                                  ? "Suspend"
                                  : "Unsuspend"}
                              </div>
                              <div
                                className="isRed py-2"
                                onClick={() =>
                                  setDelete({
                                    ...deleteUser,
                                    modal: true,
                                    users: [...deleteUser.users, item.id],
                                  })
                                }
                              >
                                Delete
                              </div>
                            </div>
                          </div>
                        )}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            ) : (
              <div className="w-100 sectionHeight--mid center pt-4">
                <h2 className="sectionHead--small textIsBold textIsGreen">
                  No supplier found
                </h2>
              </div>
            )
          ) : (
            <Spinner big />
          )}
          <div className="d-flex justify-content-end">
            <Pagination
              onChange={onPageChange}
              page={approvedSuppliers?.current_page}
              total={approvedSuppliers?.total}
              per_page={approvedSuppliers?.per_page}
            />
          </div>
        </div>
      </div>

      <EditSupplierModal
        show={edit.modal}
        user={edit.user}
        handleClose={() =>
          setEdit({
            ...edit,
            modal: false,
          })
        }
      />
      <DeleteModal
        show={deleteUser.modal}
        users={deleteUser.users}
        handleClose={() =>
          setDelete({
            ...deleteUser,
            modal: false,
          })
        }
        supplier
      />
      <SuspendModal
        show={suspendUser.modal}
        users={suspendUser.users}
        handleClose={() =>
          setSuspend({
            ...suspendUser,
            modal: false,
          })
        }
      />

      <UnSuspendModal
        supplier
        show={UnSuspendUser.modal}
        users={UnSuspendUser.users}
        handleClose={() =>
          setUnsuspend({
            ...UnSuspendUser,
            modal: false,
          })
        }
      />
    </motion.div>
  );
}

const mapStateToProps = (state) => ({
  approvedSuppliers: state.admin.suppliers.approved,
  accessToken: state.admin.token,
});

const mapDispatchToProps = (dispatch) => ({
  getApprovedSuppliers: (token, success) =>
    dispatch(fetch_approved_suppliers(token, success)),
  searchApprovedSuppliers: (token, type, value, success) =>
    dispatch(search_approved_suppliers(token, type, value, success)),
});

export default connect(mapStateToProps, mapDispatchToProps)(AllSuppliers);
